<div mat-dialog-content>
  <h5 class="gul-font-color uk-margin-small-top">The maximum file size allowed is 200KB!</h5>
</div>
<div mat-dialog-actions class="uk-width-1-1 uk-flex uk-flex-center uk-margin-small-top">
  <button mat-dialog-close class="uk-button gul-button gul-button-default" style="width: 40px;">OK</button>
</div>
